export function mergeNewMessages(prevMessages, newMessages) {
  return [
    ...prevMessages,
    ...newMessages.filter(
      (newMsg) =>
        !prevMessages.some(
          (prevMsg) =>
            prevMsg.user === newMsg.user &&
            prevMsg.message === newMsg.message
        )
    ),
  ];
}
